export interface IAuthDwhData {
    action: EAuthDwhAction;
    source?: string;
}

export enum EAuthDwhAction {
    licenseOpen = 'license-open',
    licenseAccept = 'license-accept',
    licenseReject = 'license-reject',
}

export interface IToolbarActionAnalyticsParams {
    action: string;
    source: string;
    count_files: number;
    items?: any;
}

export interface ISearchRadarData {
    dwhData: {
        [key: string]: string | number | boolean | undefined;
    };
    files?: any[];
}
